import { emailFlowService } from '../services'

const state = {
    loading: false,
    flow: {
        sections: [],
        enabled: false,
    },
}

const actions = {

    load ({ dispatch, commit }) {
        commit('loadRequest')
        emailFlowService.load().then(
            response => {
                commit('loadSuccess', response)
            },
            error => {
                commit('loadError')
                dispatch('alert/error', 'Unable to load email flow: ' + error, { root: true })
            }
        )
    },

    save ({ dispatch, commit }, params) {
        commit('loadRequest')
        emailFlowService.save(params).then(
            response => {
                commit('loadSuccess', response)
                dispatch('alert/success', 'Updates saved successfully', { root: true })
            },
            error => {
                commit('loadError')
                dispatch('alert/error', 'Unable to save email flow: ' + error, { root: true })
            }
        )
    },

}

const mutations = {
    loadRequest (state) {
        state.loading = true
    },
    loadSuccess (state, data) {
        state.loading = false
        state.flow = data.flow
    },
    getAllError (state) {
        state.loading = false
    },
}

const getters = {
    flow (state) {
        return state.flow;
    },
    isLoading(state) {
        return state.loading === true;
    }
}

export const emailFlowModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
